export default async (context) => {
    if(context.temporaryData.type === 'video' ) {
        if(context.main[context.temporaryData.index]) {
            if(context.main[context.temporaryData.index].type === 'text') {
                context.video_editor_delete_two_element(context)
            }
        } else {
            context.video_editor_delete_one_element(context)
        }
    } else if(context.temporaryData.type === 'text') {
        if(context.main[context.temporaryData.index]) {
            if(context.main[context.temporaryData.index].type === 'video') {
                context.video_editor_delete_two_element(context)
            }
        } else {
            context.video_editor_delete_one_element(context)
        }
    } else if(context.temporaryData.type === 'music') {
        await context.$store.dispatch('music/setMusic', {
            music: false
        })
        context.close_popup(context)
        context.temporaryData = false
        context.editElementStatus = false
    }
}